import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComumModule } from '../../../shared/comum.module';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { ServiceAppService } from '../../../security/service-app.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { StatusOperacaoComponent } from './status-operacao.component';
import { StatusOperacaoFiltroService } from './status-operacao-filtro.service';
import { StatusOperacaoService } from './status-operacao.service';

export function translateHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    ComumModule,
    DropdownModule,
    TranslateModule.forRoot(translateLoaderNBS),
    TableModule,
    DialogModule,
    PaginatorModule,
    ButtonModule,
    ToastModule,
    TooltipModule,
    InputTextModule,
    CalendarModule
  ],
  exports: [
    StatusOperacaoComponent
  ],
  declarations: [
    StatusOperacaoComponent
  ],
  providers: [
    ServiceAppService,
    StatusOperacaoFiltroService,
    StatusOperacaoService,
    DatePipe
  ]
})
export class StatusOperacaoModule { }
